module.exports = __webpack_public_path__ + "img/ryzs3.c8bda060.png";